define('jquery.1508.appendItem',['jquery'],
    function ($) {
        var mainNavigationChildren = $('.main-navigation > ul > li:not(".search-list")').clone(),
            footerNavigation = $('.footer-list li').clone(),
            serviceNavigation = $('.service-navigation ul li').clone().get().reverse(),
            childNavigation = $('.child-navigation').clone(),
            search = $('.main-navigation .search-list'),
            frontnav = $('<ul class="front-nav" style="display:none"/>'),
            isDesktop = true,
            //Find urls in mainNavigationChildren to array, so that we can compare it with footerNavigation for doublets
            mainNavUrls = mainNavigationChildren.map(function (index, element) { return $(element).find("a[href]")[0] + ""; }).toArray();

        //Check for doublets between mainNavigationChildren and footerNavigation
        mainNavigationChildren = mainNavigationChildren.add(footerNavigation.filter(function (index, element) {
            return mainNavUrls.indexOf($(element).find("a[href]")[0] + "") === -1;
        }));

        //append the mainnavigation and service.. (no comments)
        $('.mobile-navigation').append(mainNavigationChildren);
        $('.mobile-navigation').append(serviceNavigation);
        // find the right parent for the child 
        var parent = $('.mobile-navigation .active');
        if (parent.length > 0) {
            parent.after(childNavigation);
        }

        $(window).resize(function () {
            if (Modernizr.mq('only screen and (max-width: 768px)')) {
                if (isDesktop) {
                    $('#main-navigation .section-container').css({ 'visibility': 'visible' });

                    frontnav.show();
                    $('.frontpage').addClass('mobileView');

                    //move search to mobile navigation
                    $('.mobile-navigation').append(search);
                    isDesktop = false;
                }
            } else {
                if (!isDesktop) {
                    frontnav.hide();
                    $('.frontpage').removeClass('mobileView');

                    //move search to desktop navigation
                    $('.main-navigation ul').append(search);

                    isDesktop = true;

                }
            }
        });

        
        // Mobile megamenu
        // Find menuitems with megamenu and remove link href
        // Also hide other menues when open megamenu + add the down arrow
        var navigationItems = $(".mobile-navigation > li");
        navigationItems.each(function() {
            var $this = $(this);
            var megamenu = $(".megamenu");
            var menuOriginalHeight = $(".mobile-navigation").outerHeight();
            $this.addClass("menuitem");
            if($this.find(megamenu).children().length > 0) {
                $this.find("> a").attr("href", "#");
                $this.on("click", function() {
                    // Find megamenu height and override height on mobile-navigation
                    var megamenuHeight = $(this).find(megamenu).outerHeight();
                    var newHeightWithBuffer = megamenuHeight + 200;
                    $(".mobile-navigation").css("height", newHeightWithBuffer + "px");

                    $this.toggleClass("arrow");
                    $this.toggleClass("menuitem");
                    $this.find(megamenu).slideToggle("500", function() {
                        if($(this).is(':hidden')) {
                            var state = "closed";
                        } else {
                            var state = "open";
                        }
                        if(state === "open") {
                            $(".menuitem").hide();
                        } else {
                            $(".mobile-navigation").css("height", menuOriginalHeight + "px");
                            $(".menuitem").show();
                        }
                    });
                });
            }
        });

    });

